import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId70301: SiteIdOverrideConfig = {
  flight: {
    heading: {
      locTitleToken: "wizard.cheaptickets.flights.title",
    },
  },
  package: {
    heading: {
      locTitleToken: "wizard.cheaptickets.packages.title",
    },
    lobLabels: {
      hotelsLabel: "wizard.cheaptickets.hotels.tab.label",
    },
  },
  hotel: {
    heading: {
      locTitleToken: "wizard.cheaptickets.hotels.title",
    },
    navigation: {
      tabTitleToken: "wizard.cheaptickets.hotels.tab.label",
    },
  },
  lx: {
    heading: {
      locTitleToken: "wizard.cheaptickets.activities.title",
    },
  },
  car: {
    heading: {
      locTitleToken: "wizard.cheaptickets.cars.title",
    },
  },
};
